<template>
  <b-row>
    <b-col cols="12">
      <EXCMMessageForm
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :id-sender-type="idSenderType"
        :recipient="recipient"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMMessageForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmmessage/create')

export default {
  components: {
    EXCMMessageForm
  },
  props: {
    idSenderType: {
      required: false,
      default: null
    },
    recipient: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      item: {
        senderType: this.idSenderType,
        messageType: 1,
        subject: '',
        content: '',
        contentEmail: '',
        recipient: this.recipient,
        plannedSending: '',
        approvalStatus: '1'
      }
    }
  },
  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
    }
  },
  methods: {
    ...mapActions([
      'create'
    ]),
    onSendForm () {
      this.create(this.item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
